import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ALLOCATION_TYPES, PARTICIPANT_ALLOCATION_OPTIONS } from "../../constants/enums";
import { ROUTES } from "../../constants/clientRoutes";
import i18n from "../../i18n/config";
import { RootState } from "../../types/redux";
import { AllocationType } from "../../types/api/allocations";
import { useSelector } from "react-redux";
import AllocationsApi from "../../api/allocations";
import useErrorModal from "../../hooks/useErrorModal";
import { WizardChildProps } from "../../types/props";

import AllocationTable from "../../components/Allocations/AllocationTable";
import Card from "../../components/Common/Card";

const AllocationConfirmation = (props: WizardChildProps) => {
  const { location, setTitle, setForwardButton } = props;
  const openErrorModal = useErrorModal();
  const { type } = location?.state ?? {};
  const { allocationsToSubmit } = useSelector((state: RootState) => state.allocations);
  const history = useHistory();

  const hasData = !!type && !!allocationsToSubmit?.length;

  const initialForwardButtonState = {
    text: i18n.t("COMMON.CONFIRM"),
    onClick: () => handleSubmit(),
    disabled: false,
    loading: false,
  };

  let title = i18n.t("PAGES.ALLOCATIONS.CONFIRMATION.TITLE");
  let backRoute: string;

  switch (type) {
    case ALLOCATION_TYPES.ALL_TO_CARD:
      title = `${title}: ${i18n.t("PAGES.ALLOCATIONS.CONFIRMATION.TITLES.ALL_TO_CARD")}`;
      break;
    case ALLOCATION_TYPES.PERCENTAGE:
      title = `${title}: ${i18n.t("PAGES.ALLOCATIONS.CONFIRMATION.TITLES.PERCENTAGE")}`;
      break;
    case ALLOCATION_TYPES.FIXED:
      title = `${title}: ${i18n.t("PAGES.ALLOCATIONS.CONFIRMATION.TITLES.FIXED")}`;
      break;
  };

  useEffect(() => {
    if (!hasData) {
      history.replace(ROUTES.ALLOCATIONS.INDEX);
      return;
    }

    window.scrollTo(0, 0);
    setTitle(title);
    setForwardButton(initialForwardButtonState);
  }, []);

  if (!hasData) {
    return null;
  }

  const handleSubmit = async () => {
    setForwardButton({ ...initialForwardButtonState, loading: true });
    try {
      const requestBody = getRequestBody();
      await AllocationsApi.UpdateAllocations(requestBody);
      history.push(ROUTES.ALLOCATIONS.INDEX);
    } catch (err) {
      setForwardButton(initialForwardButtonState);
      openErrorModal(err);
    }
  }

  const getRequestBody = () => {
    const allocations = allocationsToSubmit.map((allocation: AllocationType) => {
      return {
        id: allocation.id,
        flat: allocation.fixed,
        percent: allocation.percentage,
        isFreeTransfer: allocation.selected,
        participantAllocationOptionId: allocation.percentage > 0 ? PARTICIPANT_ALLOCATION_OPTIONS.PERCENT : PARTICIPANT_ALLOCATION_OPTIONS.FLAT
      }
    });

    return {
      allocations
    }
  }

  return (
    <>
      <p>{i18n.t("PAGES.ALLOCATIONS.CONFIRMATION.SUBTITLE")}</p>
      <Card
        fullWidth
        bodyPadding="flush"
        className="mb-16"
        title={"Allocations"}
        data-cy="allocation-confirmation"
      >
        <AllocationTable
          isAvailableTableType={true}
          allocations={allocationsToSubmit}
          showStatusCol={false}
          handleInfoTipModal={() => { }}
        />
      </Card>
    </>

  );
}

export default AllocationConfirmation;